<template>
    <v-container v-if="sample">
        <v-tabs
                slot="extension"
                v-model="model"
                centered
                color="secondary"
                slider-color="primary"
                class="elevation-10"
        >
            <v-tab
                    href="#tab-info"
            >
                Sample request info
            </v-tab>
            <v-tab
                    v-if="sample.status_id == 4"
                    href="#tab-documents"
            >
                Shipment Documents
            </v-tab>
        </v-tabs>

        <v-tabs-items
                v-model="model"
                class="elevation-10"
        >
            <v-tab-item
                    value="tab-info"
            >
                <v-card flat>
                    <InfoComponent :sample="sample" v-if="model == 'tab-info'"></InfoComponent>
                </v-card>
            </v-tab-item>
            <v-tab-item
                    value="tab-documents"
            >
                <v-card flat>

                </v-card>
            </v-tab-item>
            <v-tab-item
                    v-if="sample.status_id == 4"
                    value="tab-documents"
            >
                <v-card flat>
                    <DocumentComponent v-if="model == 'tab-documents'" :order_id="id" :sample="sample"></DocumentComponent>
                </v-card>
            </v-tab-item>
        </v-tabs-items>
    </v-container>
</template>

<script>
    import InfoComponent from './views/InfoComponent';
    import DocumentComponent from './views/DocumentComponent';

    export default {
        props: ['id'],
        data () {
            return {
                model: 'tab-',
                sample: null,
                comments: null
            }
        },
        created () {
            this.getSampleOrderDetail();
            if (this.$route.query.model == 'tab-info') {
                this.model = 'tab-info';
            }
            if (this.$route.query.model == 'tab-documents') {
                this.model = 'tab-documents';
            }
        },
        methods: {
            getSampleOrderDetail () {
                this.$store.dispatch('getSampleOrderDetail', {
                    id: this.id
                }).then((res) => {

                    this.sample = res.data.data;
                    this.model = 'tab-info';

                }).catch((error) => {

                });
            }
        },
        components: {
            InfoComponent,
            DocumentComponent
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/agent/samples/DetailComponent.vue